<template>
  <div>
    <el-card>
      <div class="block">
        <el-form :inline="true">
          <el-form-item label="日期">
            <el-date-picker
                v-model="dateRange"
                value-format="yyyy-MM-dd HH:mm:ss"
                type="datetimerange"
                :picker-options="pickerOptions"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                align="right">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="去中心化场所:">
            <el-select v-model="chain" placeholder="请选择去中心化场所">
              <el-option v-for="item in exchangeChainEnum" :key="item.label" :value="item.key" :label="item.label"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="币种类型:">
            <el-autocomplete popper-class="my-autocomplete" v-model="symbol" :fetch-suggestions="querySearch" placeholder="请输入币种类型" @select="handleSelect">
              <i class="el-icon-edit el-input__icon" slot="suffix" @click="handleIconClick"></i>
              <template slot-scope="{ item }"><div class="name">{{ item.value }}</div></template>
            </el-autocomplete>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" icon="el-icon-search" :plain="true" @click="queryDecentralizationBalance">查询</el-button>
          </el-form-item>
        </el-form>

        <div class="top" v-if="isShow">
          <el-table :data="tableData" style="width: 100%" max-height="1000" border>
            <el-table-column prop="chain" label="DECENTRALIZED PLACE" sortable></el-table-column>
            <el-table-column prop="tokenName" label="TOKEN NAME" sortable></el-table-column>
            <el-table-column prop="symbol" label="SYMBOL" sortable></el-table-column>
            <el-table-column prop="quantity" label="QUANTITY" sortable></el-table-column>
            <el-table-column prop="totalEth" label="VALUE IN ETH" sortable></el-table-column>
            <el-table-column prop="totalUsd" label="VALUE IN USD" sortable></el-table-column>
            <el-table-column prop="requestAddr" label="REQUEST ADDRESS" sortable></el-table-column>
            <el-table-column prop="snapshotTime" label="SNAPSHOT TIME" sortable></el-table-column>
          </el-table>
          <el-pagination background
                         layout="total, sizes, prev, pager, next, jumper"
                         :page-size="pageSize"
                         :page-sizes="[1, 10, 20, 30, 40, 50, 60, 70, 80, 90, 100]"
                         :total="total"
                         :current-page="currentPageNum"
                         @size-change="handleSizeChange"
                         @current-change="handleCurrentChange">
          </el-pagination>
          <div style="text-align:right">
            <el-button type="success" plain @click="exportExcel(params1)">全量导出excel</el-button>
            <el-button type="success" plain @click="exportExcel(params)">当前页导出excel</el-button>
          </div>
        </div>
      </div>
    </el-card>
  </div>
</template>

<script>
import './store'
import {mapActions, mapState} from "vuex";
import utils from "@/entries/HedgeCenter/BalanceBook/utils";

const columns=[
  {title:'DECENTRALIZED PLACE',key:'chain'},
  {title:'TOKEN NAME',key:'tokenName'},
  {title:'SYMBOL',key:'symbol'},
  {title:'QUANTITY',key:'quantity'},
  {title:'VALUE IN ETH',key:'totalEth'},
  {title:'VALUE IN USD',key:'totalUsd'},
  {title:'REQUEST ADDRESS',key:'requestAddr'},
  {title:'SNAPSHOT TIME',key:'snapshotTime'}
]

export default {
  name: "DecentralizationBalance",
  data(){
    return {
      pages:0,
      total:0,
      buffer:'',
      currentPageNum:1,
      pageSize:20,
      isShow:false,
      chain:'',
      symbol: '',
      activeName:'part1',
      dateRange:[],
      tableData:[],
      restaurants:[],
      binanceSub: 0,
    }
  },
  methods:{
    ...mapActions('balanceReconciliation', ['queryExchangeChainEnum']),

    handleSizeChange(val){
      this.params.pageSize = val
      this.queryDecentralizationBalance()
    },

    handleCurrentChange(val) {
      this.params.pageNum = val
      this.queryDecentralizationBalance()
    },

    querySearch(queryString, cb) {
      let restaurants = this.restaurants;
      let results = queryString ? restaurants.filter(this.createFilter(queryString)) : restaurants;
      cb(results);
    },

    handleSelect(item) {},
    handleIconClick(ev) {},

    queryDecentralizationBalance (){
      if (this.dateRange.length === 0){
        this.$message.error("请选择日期")
        return
      }
      if (this.chain === ""){
        this.$message.error("请选择去中心化场所")
        return
      }
      if (this.buffer === ''){
        this.buffer = this.paramsBak
      } else {
        if (this.buffer !== this.paramsBak){
          this.params.pageNum = 1
          this.buffer = this.paramsBak
        }
      }
      utils.pageQueryChainBalanceSnapshot(this.params).then((response=>{
        this.isShow = true
        this.total = response.data.total
        this.pages = response.data.pages
        this.pageSize = response.data.size
        this.currentPageNum = response.data.current
        let tableData = response.data.records
        for (let key in tableData){
          tableData[key].createTime = utils.getLocalTime(tableData[key].createTime)
          tableData[key].snapshotTime = utils.getLocalTime(tableData[key].snapshotTime)
        }
        this.tableData = tableData
      }))
    },

    exportExcel (data){
      utils.queryChainBalanceSnapshot(data).then((response=>{
        let startTime = utils.getLocalTime(this.dateRange[0])
        let endTime = utils.getLocalTime(this.dateRange[1])
        let title = '去中心化资产' + startTime + '-' + endTime
        let data = response.data
        for (let key in data){
          data[key].createTime = utils.getLocalTime(data[key].createTime)
          data[key].snapshotTime = utils.getLocalTime(data[key].snapshotTime)
        }

        utils.export2Excel(columns, data, title)

      }))
    }

  },
  computed: {
    ...mapState('balanceReconciliation', ['exchangeChainEnum', 'pickerOptions']),
    params() {
      return {
        startTime:new Date(this.dateRange[0]).getTime(),
        endTime:new Date(this.dateRange[1]).getTime(),
        symbol: this.symbol,
        chain: this.chain,
        pageSize: this.pageSize,
        pageNum: this.currentPageNum
      };
    },
    params1() {
      return {
        startTime:new Date(this.dateRange[0]).getTime(),
        endTime:new Date(this.dateRange[1]).getTime(),
        symbol: '',
        chain: '',
      };
    },
    paramsBak() {
      return {
        dateRange:this.dateRange,
        symbol: this.symbol,
        chain: this.chain,
      };
    },
  },
  created() {
    this.queryExchangeChainEnum()
  },
  watch:{
  },
}
</script>

<style scoped>

</style>